import React, {useState} from 'react';

import './HomeYoutubeTopTenTab.css';

// const getSummary = (content) => {
//   let summary = content;
//   if(summary.length > 15) {
//     summary = summary.substr(0, 15) + "...";
//   }
//   return summary;
// }

//props => calcDate, TopTenData;
const HomeYoutubeTopTenTab = (props) => {
  const youtubeCategory = props.youtubeCategory;
  const youtubeTabContents = props.youtubeTabContents;
  const [youtubeTab, setYoutubeTab] = useState('AL');

  const CategoryLabel = ({category}) => {
    switch(category) {
      case 'AL':
        return (<>전체</>)
      case '24':
        return (<>엔터테인먼트</>)
      case '20':
        return (<>게임</>)
      case '10':
        return (<>음악</>)
      case '25':
        return (<>뉴스</>)
      default:
        return (<></>);
    }
  }

  const PubDate = ({pubdate})=> {
    let year = pubdate.substr(0,4);
    let month = pubdate.substr(4,2);
    let day = pubdate.substr(6,2);
    return <>{year+"-"+month+"-"+day}</>
  }

  return (
    <>
			<div className="parbase badgea spanMargin">              
        <div className="span4">
          <div className="mainTitle nielsen-aqua">YOUTUBE HASHTAG KEYWORD TOP 10<div>
            <div className="KwBox">
              <div className="KWtabmenu">
                {youtubeCategory.map((item, index) => {
                  return(
                    <>
                      <input id={`tab`+item.category} type="radio" name="tabs" checked={item.category==youtubeTab ? true:false}/>
                      <label id={`tab`+item.category} onClick={()=>setYoutubeTab(item.category)}>
                        <CategoryLabel category={item.category} />
                      </label>
                    </>
                  )
                })}
              </div>
              <section id={`content`+youtubeTab}>
                <table className="tablestyMain">
                  <tbody>
                  <tr>
                    <th width="20%">순위</th>
                    <th width="50%">키워드</th>
                    <th width="30%">증감률(%)</th>
                  </tr>
                  {youtubeTabContents.filter(item => {
                    return item.category==youtubeTab
                  }).map((contentItem,contentIndex) => {
                    return(
                      <tr>
                        <td width="20%">
                          {contentIndex+1}
                        </td>
                        <td width="50%">
                          {contentItem.keyword}
                        </td>
                        <td width="30%">
                          {contentItem.ratio == "NEW" ?
                            <span className="youtube-tab-new">{contentItem.ratio}</span>
                            : contentItem.ratio}
                        </td>
                      </tr>
                    )
                  })}
                  </tbody>
                </table>
                <div className="UpdateDate"><PubDate pubdate={props.youtubePubDate} /></div>
              </section>
            </div>
            </div>
          </div>
        </div>
        </div>
    </>
  )
}

export default HomeYoutubeTopTenTab;